<template>
  <PageView
    class="LoginView"
    :has-menu="false"
  >
    <div class="columns">
      <div class="column is-3">
        <h1 class="title main-title">
          {{ $t("titles.login-page") }}
        </h1>
        <img
          class="logo_openADOM"
          src="@/assets/Logo_OpenADOM.svg"
          alt="The Open ADOM Logo"
        >
      </div>
      <div class="column is-offset-1 is-8">
        <div class="main-content">
          <div class="card-login">
            <b-tabs
              v-model="selectedTab"
              class="buttonRubriquePanel"
            >
              <b-tab-item style="width: 100%;">
                <template #header>
                  <span
                    class="rubriqueTitle"
                    :aria-label="$t('login.signin')"
                  >
                    <b-icon icon="sign-in-alt" />
                    {{ $t("login.signin") }}
                  </span>
                </template>
                <SignIn />
              </b-tab-item>
              <b-tab-item style="width: 100%;">
                <template #header>
                  <span
                    class="rubriqueTitle"
                    :aria-label="$t('login.register')"
                  >
                    <b-icon icon="user-plus" />
                    {{ $t("login.register") }}
                  </span>
                </template>
                <UserRegister @user:registered="changeTabToSignIn()" />
              </b-tab-item>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <div class="links columns">
      <a
        class="column"
        :aria-label="$t('footer.legal-notice.title')"
        href="/legal-notice"
      > {{ $t("footer.legal-notice.title") }}</a>
      <a
        class="column"
        :aria-label="$t('footer.cgu.title')"
        href="/cgu"
      > {{ $t("footer.cgu.title") }}</a>
      <!--TODO        <a class="column">Gestion données personnelles</a>-->
    </div>
    <FooterView />
  </PageView>
</template>

<script lang="ts">
import SignIn from "@/components/login/Signin.vue";
import PageView from "./common/PageView.vue";
import useText from "@/composable/components/text";
import useNumber from "@/composable/components/number";
import { provide } from "vue";
import FooterView from "@/views/common/FooterView.vue";
import { BIcon, BTabItem, BTabs } from "buefy";
import "@/style/views/LoginView.scss";

const { refNumber: selectedTab, doChangeNumber } = useNumber();

export default {
  name: "LoginView",
  components: { BTabs, BTabItem, BIcon, FooterView, PageView, SignIn },
  setup() {
    provide("login", useText().refText);
    provide("email", useText().refText);
    provide("changeTabToSignIn", changeTabToSignIn);
    function changeTabToSignIn() {
      doChangeNumber(0);
    }
    return {
      // from "@/composition/components/number"
      selectedTab,
      changeTabToSignIn,
    };
  },
};
</script>
